import SingleObjectResource, {setConfig} from 'tg-resources';

import logger from '../logger';
import CurrentUserActions from '../actions/CurrentUserActions';

import {getExtraHeaders, getCookies} from './headers';


// Configure tg-resources
if (!process.env.BROWSER) {
    DJ_CONST.API_BASE = DJ_CONST.API_BASE_SERVER;
}
logger.debug('Configuring tg-resources, API_BASE is', DJ_CONST.API_BASE);
setConfig('API_BASE', DJ_CONST.API_BASE);
setConfig('onSourceError', CurrentUserActions.pageFault);
setConfig('getExtraHeaders', getExtraHeaders);
setConfig('getCookies', getCookies);


class WithoutBaseResource extends SingleObjectResource {
    constructor(apiEndpoint, expectedStatus, mutateResponse) {
        super(apiEndpoint, expectedStatus, mutateResponse);
        this.apiEndpoint = apiEndpoint;
    }
}


export default SingleObjectResource;
export {WithoutBaseResource};
export {InvalidResponseCode, ValidatonError} from 'tg-resources';



/** WEBPACK FOOTER **
 ** ./app/src/resources/GenericResource.js
 **/